import {getStringSha256Hash, isNil} from '../../helpers'

const showPopup = (_event) => {
    _event.preventDefault();
    const element = _event.currentTarget;
    createPopupBox(element);
}

const removePopup = (_event) => {
    _event.preventDefault();
    const element = _event.currentTarget;

    const popups = Array.from(element.querySelectorAll('.popup-title'));
    popups.forEach(_popup => {
        if (!isNil(_popup)) {
            _popup.remove();
        }
    });
}

const createPopupBox = (element) => {
    let popup = document.createElement('div');
    const title = element.getAttribute('data-title');
    const identifier = Math.abs(getStringSha256Hash(title));
    popup.innerText = title;
    popup.classList.add('popup-title');
    popup.setAttribute('id', identifier);
    element.appendChild(popup);
    return popup;
}

export default class TitlePopup {
    constructor(_selector) {
        this._items = Array.from(document.querySelectorAll(_selector))
    }

    init() {
        // disable on mobile
        if (!document.body.classList.contains('platform-mobile')) {
            this._setupEventListeners()
        }
    }

    destroyAll() {
        const popups = Array.from(document.querySelectorAll('.popup-title'));
        popups.forEach(_popup => {
            if (!isNil(_popup)) {
                _popup.remove();
            }
        });

        this._items.forEach(_item => {
            _item.removeEventListener('mouseover', showPopup, true);
            _item.removeEventListener('mouseleave', removePopup, true);
        });
    }

    _setupEventListeners() {
        this._items.forEach(_item => {
            _item.addEventListener('mouseover', showPopup, true)
        });

        this._items.forEach(_item => {
            _item.addEventListener('mouseleave', removePopup, true)
        });
    }
}



// WEBPACK FOOTER //
// ./Private/Scripts/components/popup/TitlePopup.js